export default __webpack_public_path__ + "static/media/image.icreative-works-pvt-ltd.ee9935c7.png";